// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1WsGP","vLegacy":"SelectSecondary_vLegacy__1qJXc","error":"SelectSecondary_error__2zA0P","disabled":"SelectSecondary_disabled__3DE3C"};